import {View} from "@dp-instant/2d";
import {injectable} from "inversify";
import {IBuilding} from "../interfaces/IBuilding";
import {TextStyle, Text, BitmapFont, BitmapText} from "pixi.js-legacy";

@injectable()
export class Population extends View {
    public static readonly BLOCK_POPULATION_SECONDS = 0.5;
    public static SPAWN_AMOUNT_ON_OCCUPATION = 0;

    constructor() {
        super();
    }
    setPopulationLimit(value: number) {
        this._populationLimit = value;
    }
    setPopulationRate(value: number) {
        this._populationSpeed = value;
        this._rate = 1 / value;
    }
    get lastBlockTimestamp(): number {
        return this._lastBlockTimestamp;
    }
    private _active = true;
    get active(): bool {
        return this._active;
    }
    set active(value: bool) {
        this._active = value;
        this.alpha = this._active ? 1 : 0.25;
        this._label.visible = this._active;
    }

    private _populationSpeed = 1.5;
    private _populationLimit = 60;
    private _rate = 1000; // -1;
    private _lastSpawnTimestamp = -1;
    private _lastBlockTimestamp = -1;
    private _current = 0;
    private _label: Text | BitmapText;
    private updateLabel = () => {
        // this._label.text = "" + (this._current/this.cap);
        this._label.text = "" + this._current;
        this._label.x = -this._label.width * 0.5;
    };

    init(data: IBuilding) {
        this._label = new BitmapText("-", {fontName: "Helvetica"});
        this._label.y = data.stateRadius;
        this.position.set(...data.statePos);
        this.addChild(this._label);
        this.updateLabel();
    }
    public block() {
        this._lastBlockTimestamp = Date.now();
    }
    public allocate(amount: number) {
        const left = Math.max(this.current - amount, 0);
        const removed = Math.max(this.current - left, 0);
        this.current = left;
        if (removed > 0) {
            this.block();
        }
        return removed;
    }
    public remove(amount: number) {
        const curr = this.current;
        const left = Math.max(curr - amount, 0);
        const removed = Math.max(curr - left, 0);
        this.current = left;
        return removed;
    }
    public tryPopulate(dt = 0) {
        const now = Date.now();
        if (this._lastSpawnTimestamp == -1) this._lastSpawnTimestamp = now;

        const timePassed = (now - this._lastSpawnTimestamp) / 1000;

        if (timePassed >= this._rate) {
            if (this._current < this._populationLimit) {
                if (now - this._lastBlockTimestamp >= Population.BLOCK_POPULATION_SECONDS * 1000)
                    this.current += 1;
            }

            const timeLeft = timePassed - this._rate;
            this._lastSpawnTimestamp = now - timeLeft;
        }
    }
    public get current() {
        return this._current;
    }
    public set current(value: number) {
        this._current = value;
        this.updateLabel();
    }
    public get cap(): number {
        return this._populationLimit;
    }
}
